<div class="d-print-none">
  <app-base-inline-form
    [header]="header()"
    [fields]="fields"
    [labelsVertical]="labelsVertical()"
    [fieldsVertical]="fieldsVertical()"
    [model]="model"
  ></app-base-inline-form>

  <app-grid
    [gridCssClass]="gridCssClass()"
    [stateKey]="gridStateKey"
    [layoutStateKey]="layoutStateKey"
    [columnDefs]="columnDefs()"
    [rowData]="rowData$ | async"
    [filter]="filter()"
    [resizable]="resizable()"
    [sortable]="sortable()"
    [showDelete]="showDelete()"
    [showDeleteMessage]="showDeleteMessage()"
    [importService]="importService()"
    [showPrint]="showPrint()"
    [showLayouts]="showLayouts()"
    [retainState]="retainState()"
    [serverSide]="serverSide()"
    [pageSize]="pageSize()"
    (edit)="onEdit($event)"
    (print)="print.emit($event)"
    (delete)="onDelete($event)"
    (rowSelected)="rowSelected.emit($event)"
    (imported)="imported()"
    (savedState)="savedState()"
    (firstDataRendered)="onFirstDataRendered()"
    (serverSideSearch)="serverSideSearch($event, true)"
  ></app-grid>
</div>
